import { Link, useLocation } from "react-router";
import { ArcanaLogo } from "@/components/custom/arcana-logo";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import type { SidebarMenuGroup, SidebarMenuItem as DashboardMenuItem } from "@/components/layouts/dashboard-nav-types";

type AppSidebarProps = {
  menus: SidebarMenuGroup[];
  activePath?: string;
};

// const footerLinks = [
//   {
//     id: "documentation",
//     label: "Documentation",
//     icon: <BookOpenText className="size-4" />,
//     href: "#",
//   },
//   {
//     id: "support",
//     label: "Support",
//     icon: <CircleHelp className="size-4" />,
//     href: "#",
//   },
// ];

export function AppSidebar({ menus, activePath }: AppSidebarProps) {
  const location = useLocation();
  const currentPath = activePath ?? location.pathname;

  return (
    <Sidebar collapsible="offcanvas" className="border-r border-sidebar-border">
      <SidebarHeader className="px-3 py-4">
        <ArcanaLogo variant="compact" className="opacity-95" />
      </SidebarHeader>
      <SidebarContent className="px-2 py-1">
        {menus.map((group, index) => (
          <SidebarGroup key={group.label ?? index}>
            {group.label && <SidebarGroupLabel>{group.label}</SidebarGroupLabel>}
            <SidebarGroupContent>
              <SidebarMenu>
                {group.items.map((item) => renderSidebarMenuItem(item, currentPath))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        ))}
      </SidebarContent>
      {/*<SidebarFooter className="border-t border-sidebar-border px-2 py-3">
        <SidebarMenu>
          {footerLinks.map((item) => (
            <SidebarMenuItem key={item.id}>
              <SidebarMenuButton asChild tooltip={item.label}>
                <a href={item.href}>
                  {item.icon}
                  <span>{item.label}</span>
                </a>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarFooter>*/}
    </Sidebar>
  );
}

function renderSidebarMenuItem(item: DashboardMenuItem, currentPath: string) {
  if (item.isText) {
    return (
      <SidebarMenuItem key={item.id} className="rounded-md border border-border bg-muted/40 p-2">
        <span className="w-full px-2 text-sm text-muted-foreground">{item.label}</span>
        <small className="block px-2 text-xs text-muted-foreground">{item.description}</small>
      </SidebarMenuItem>
    );
  }

  const isActive = currentPath === item.href || currentPath.startsWith(`${item.href}/`);

  return (
    <SidebarMenuItem key={item.id}>
      <SidebarMenuButton asChild isActive={isActive} tooltip={item.label}>
        <Link to={item.href}>
          {item.icon}
          <span>{item.label}</span>
          {item.badge && <span className="ml-auto text-xs">{item.badge}</span>}
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}
